import {generalRequest} from "@/lib/services/requests";
import {useMutation, useQuery} from "@tanstack/react-query";
import {myAcademy} from "@/lib/services/academyService";

export const useApiSearchStudentHomeworks = (args) => {
    return useQuery({
        queryKey: ['student', 'homework', 'search', args, myAcademy()],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/student/homeworks`, config)
        })({params: args})),
    })
}

export const useApiGetStudentHomework = (args) => {
    return useQuery({
        queryKey: ['student', 'homework', 'get', args, myAcademy()],
        queryFn: () => ((async (args = {}) => {
            return generalRequest.get(`/student/homeworks/${args.id}`, args)
        })(args)),
    })
}


export const useApiStudentDoHomework = () => {
    return useMutation({
        mutationFn: (args) =>
            ((async (args = {}) => {
                return generalRequest.post(`/student/homeworks/${args.id}/reports`, args)
            })(args))
    });
}


export const useApiSearchTeacherHomeworks = (args) => {
    return useQuery({
        queryKey: ['teacher', 'homework', 'search', args, myAcademy()],
        queryFn: () => ((async (args = {}) => {
            return generalRequest.get(`/teacher/homeworks/`, {params: args})
        })(args)),
    })
}


export const useApiSearchTeacherHomeworksReports = (args) => {
    return useQuery({
        queryKey: ['teacher', 'homework', 'report', 'search', args, myAcademy()],
        queryFn: () => ((async (data = {}) => {
            return generalRequest.get(`/teacher/homeworks-reports`, {params: data})
        })(args)),
    })
}


export const useApiGetTeacherHomeworksReports = (args) => {
    return useQuery({
        queryKey: ['teacher', 'homework', 'report', 'get', args?.id, myAcademy()],
        queryFn: () => ((async (data = {}) => {
            return generalRequest.get(`/teacher/homeworks-reports/${data?.id}`)
        })(args)),
    })
}


export const useApiGetTeacherHomeworks = (args) => {
    return useQuery({
        enabled: !!args?.enabled,
        queryKey: ['teacher', 'homework', 'get', args, myAcademy()],
        queryFn: () => ((async (args = {}) => {
            return generalRequest.get(`/teacher/homeworks/${args?.id}`)
        })(args)),
    })
}


export const useApiTeacherHomeworkCreate = () => {
    return useMutation({
        mutationFn: (data) =>
            ((async (data = {}) => {
                return generalRequest.post(`/teacher/homeworks`, data)
            })(data))
    });
}


export const useApiTeacherHomeworkUpdate = () => {
    return useMutation({
        mutationFn: (data) =>
            ((async (data = {}) => {
                return generalRequest.patch(`/teacher/homeworks/${data?.id}`, data)
            })(data))
    });
}


export const useApiTeacherHomeworkReportUpdate = () => {
    return useMutation({
        mutationFn: (data) =>
            ((async (data = {}) => {
                return generalRequest.put(`/teacher/homeworks/${data?.id}/reports/${data?.report_id}`, data)
            })(data))
    });
}